module.exports = __webpack_public_path__ + "img/wishlist-now.e0311c7e.png";